import React, { useState} from "react";

const PdfForm = ({ item, onSave, onCancel }) => {
  const [className, setClassName] = useState(item?.className || "lkg");
  const [subject, setSubject] = useState(item?.subject || "");
  const [fileName, setFileName] = useState(item?.fileName || "");
  const [file, setFile] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!subject.trim() || (!file && !fileName)) {
      alert("Please fill all fields and select a PDF.");
      return;
    }

    if (file && file.type !== "application/pdf") {
      alert("Only PDF files are allowed.");
      return;
    }

    const data = {
      id: item?.id || null,
      className,
      subject,
      fileName: file ? file.name : fileName,
    };

    onSave(data);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label>Class</label>
        <select
          className="form-control"
          value={className}
          onChange={(e) => setClassName(e.target.value)}
        >
          {["lkg", "ukg", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map((cls) => (
            <option key={cls} value={cls}>
              {cls.toUpperCase()}{" "}
              {["1", "2", "3"].includes(cls)
                ? { "1": "st", "2": "nd", "3": "rd" }[cls]
                : "th"}{" "}
              Class
            </option>
          ))}
        </select>
      </div>

      <div className="mb-3">
        <label>Subject</label>
        <input
          type="text"
          className="form-control"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label>PDF File</label>
        <input
          type="file"
          accept="application/pdf"
          className="form-control"
          onChange={(e) => setFile(e.target.files[0])}
        />
        {item && !file && <small className="text-muted">Current: {fileName}</small>}
      </div>

      <div className="d-flex justify-content-between">
        <button type="submit" className="btn btn-primary">
          {item ? "Update" : "Upload"}
        </button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default  PdfForm;